import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import NextLink, { LinkProps } from '../components/link';

interface LinkElement extends Element {
  props: Element['props'] & LinkProps;
}

const link: Processor<LinkElement> = {
  priority: 10,
  name: 'link',
  test: ({ node }) => node?.component === 'a' && node?.props?.href !== undefined && !node.props?.href?.startsWith('#'),
  processor: ({ node }) => {
    if (node.props.href) {
      node.props.link = node.props.href;
    }
    node.component = NextLink as ComponentType;

    return node;
  }
};

export default link;
